import { buildLiksDateMonthGrid } from './dateRangePicker';

export type LiksDateRangeCalendarGridProps = {
  year: number;
  month: number;
  monthLabel: string;
  weekdayLabels: ReadonlyArray<string>;
  today: string;
  draftFromDay: string;
  draftToDay: string;
  onDayClick: (day: string) => void;
};

export function LiksDateRangeCalendarGrid({
  year,
  month,
  monthLabel,
  weekdayLabels,
  today,
  draftFromDay,
  draftToDay,
  onDayClick,
}: LiksDateRangeCalendarGridProps) {
  const cells = buildLiksDateMonthGrid(year, month);

  return (
    <>
      <div className="liks-date-range-dialog__weekdays" aria-hidden>
        {weekdayLabels.map((label, index) => (
          <span
            key={`${label}-${index}`}
            className="liks-date-range-dialog__weekday"
          >
            {label}
          </span>
        ))}
      </div>

      <div
        className="liks-date-range-dialog__grid"
        role="grid"
        aria-label={monthLabel}
      >
        {cells.map((cell) => {
          const isStart = cell.day === draftFromDay;
          const isEnd = cell.day === draftToDay;
          const isDisabled = cell.day > today;
          const inRange =
            !isDisabled &&
            draftFromDay !== '' &&
            draftToDay !== '' &&
            cell.day >= draftFromDay &&
            cell.day <= draftToDay;

          return (
            <button
              key={cell.day}
              type="button"
              role="gridcell"
              disabled={isDisabled}
              aria-disabled={isDisabled || undefined}
              className={[
                'liks-date-range-dialog__day',
                !cell.inMonth && 'liks-date-range-dialog__day--outside',
                isDisabled && 'liks-date-range-dialog__day--disabled',
                inRange && 'liks-date-range-dialog__day--in-range',
                isStart && 'liks-date-range-dialog__day--start',
                isEnd && 'liks-date-range-dialog__day--end',
              ]
                .filter(Boolean)
                .join(' ')}
              onClick={() => onDayClick(cell.day)}
            >
              {Number(cell.day.slice(8, 10))}
            </button>
          );
        })}
      </div>
    </>
  );
}
